import React from 'react';

const items = [
  'REKORDBOX SYNC',
  'QUICK TAG',
  'GRAPH PLAYLIST',
  'CHAPTER BUILDER',
  'ANALYTICS',
  'WATCH FOLDER',
  'BENCHMARK CENTER',
];

export default function Marquee() {
  const track = [...items, ...items, ...items, ...items];

  return (
    <div className="marquee" data-testid="marquee-section" aria-hidden="true">
      <div className="marquee-track">
        {track.map((t, i) => (
          <span key={`${t}-${i}`} className="marquee-item">{t}</span>
        ))}
      </div>
    </div>
  );
}
